import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  createReducerName,
  registryCombineReducer
} from 'mt-react-common/modules/tasks/reducers/dynamic/tasksList/combineRegistry';
import TasksList from '../../TasksList';

class TasksListByOwnerId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: createReducerName(`tasksListByOwnerId-${this.props.userId}`)
    };
  }

  componentWillMount() {
    registryCombineReducer(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <TasksList
          userId={this.props.userId}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

TasksListByOwnerId.defaultProps = {};

TasksListByOwnerId.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default TasksListByOwnerId;



// WEBPACK FOOTER //
// ./src/components/Tasks/ReducerWrappers/TasksListByOwnerId/TasksListByOwnerId.js